<template>
<div>
  <div class="trainer" v-show="!reaction">
    <div class="trainer__header">
      <div class="train__info" v-show="active">
        <div class="train__item" v-if="$route.params.isHomework" uk-tooltip="Выполнено упражнений">
          <div class="train__ico train__ico--4"></div>
          <small>Выполнено:</small>
          <div class="train__nowrap">{{ $route.params.total }} из {{ $route.params.qnt }}</div>
        </div>
        <div class="train__item" uk-tooltip="Времени прошло">
          <div class="train__ico train__ico--3"></div>
          <div>
            <small>Обратный отсчет:</small>
            <!--<br class="uk-visible@s">-->
            {{ countDown_timer.seconds }}.{{ countDown_timer.milliseconds ? (countDown_timer.milliseconds / 100) : 0 }} сек.
          </div>
        </div>
      </div>

      <div class="game__name">
        <div class="font_size" v-if="reading">
          <button uk-tooltip="уменьшить шрифт" @click="changeFontSize('-')">Аа-</button>
          <button uk-tooltip="увеличить шрифт" @click="changeFontSize('+')">Аа+</button>
        </div>
        <div class="trainer__menu">
          <div class="readtest__notify" v-if="timesup && !params.finish">
            Время вышло! Выбери слово на котором ты остановился!
          </div>
          <span v-show="!active">Настройте размер шрифта и нажмите "начать" </span>
          <div class="menu-buttons">
            <a v-show="!active" href="#" @click.prevent="startGame">Начать</a>
            <a href="#" @click.prevent="onStopTrainer">Остановить</a>
          </div>          
        </div>
        
      </div>
    </div>
    
    <div class="trainer__body readtest__body">
      <div class="readtest__text " v-show="!params.finish" :class="{ 'readtest__text--blur': !active }">
        <span v-for="(item, key) in prepareText" :key="key" @mouseover="onHoverWord(item, key, $event)" @mouseout="clearPopup($event)" @click="checkWord(item, key)">{{ item }}</span>
      </div>
      <a class="finish-btn" v-show="active" href="#" @click.prevent="onLetStop" v-if="!timesup && !params.finish">Закончил чтение</a>
    
      <div v-if="params.finish">
        <h2>Отлично! Молодец!</h2>
        <h3>
          <strong>Твой результат:</strong><br>
          <small>
            Слов в минуту: <strong>{{ result.words_per_minute }}</strong><br>
            Символов в минуту с пробелами: <strong>{{ result.symbols_space_per_minute }}</strong><br>
            Символов в минуту без пробелов: <strong>{{ result.symbols_nospace_per_minute }}</strong>
          </small>
        </h3>
        <quiz :result="result" :items="params.text.questions" v-if="hasQuestions"></quiz>
      </div>
    </div>    
  </div>

  <!-- РЕАКЦИИ -->
  <div class="wh-block wh-block--reaction" v-if="reaction">
    <div class="reaction">
      <!--<video loop muted preload="auto" autoplay>-->
      <video disableRemotePlayback preload="auto" autoplay @ended="stopReaction">
        <source type="video/mp4" :src="'/storage/app/media/reactions/' + reaction_file" id="mp4">
      </video>
    </div>
  </div>
</div>
</template>

<script>
import {
  mapState,
  mapMutations
} from 'vuex';
import {
  mix
} from "./../mixin";
import moment from "moment";
import quiz from "./quiz";

export default {
  name: "game",
  components: {
    quiz
  },
  mixins: [
    mix
  ],
  data() {
    return {
      // NEW PARAMS
      countDown_id: '',
      countDown_timer: '',
      popupTimer: '',
      reading: true,
      timesup: false,
      hasResult: false,
      result: '',
      /** Texts */
      // OLD PARAMS
      cifs: '',
      shuffle: '',
      active: false,
      step: 0,
      errors: 0,
      nextCif: '',
      currentCif: '',
      reaction: false,
      scores: 0,
    }
  },
  computed: {
    // New
    hasQuestions() {
      return !_.isEmpty(this.params.text.questions);
    },
    prepareText() {
      if (this.params.text) {
        console.log(this.params.text);
        let text = this.breakTextByWords(this.params.text.desc);
        return text;
      }
    },
    // Old
    ...mapState({
      params: state => state.train.speedtest_params
    }),
    finish() {
      return this.params.finish
    },
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    changeFontSize(val) {
      let step = 0.1;
      let cnt = document.getElementsByClassName('readtest__text');
      let current_fz = cnt[0].style.fontSize;
      let fz = current_fz ? parseFloat(current_fz) : 1;
      let result;
      if (val === '+') {
        result = fz + step;
      } else {
        result = fz - step;
      }
      cnt[0].style.fontSize = result + 'em';
    },
    // NEW METHODS
    breakTextBySpan(text) {
      let arr = text.split(' ');
      let txt = _.map(_.compact(arr), function (e) {
        return `<span>${e}</span>`;
      });
      return txt.join('');
    },
    breakTextByWords(text) {

      //console.log('brak text by words', text);
      text = _.replace(text, new RegExp('\n', 'g'), ' ');
      //text = _.replace(text, new RegExp('  ', 'g'), ' ');
      text = text.replace(/\s{2,}/g, ' ');
      //text = text.replaceAll('\n', ' ');
      //text = text.replaceAll('  ', ' ');
      let arr = text.split(' ');
      //console.log(text, arr);
      return arr;
    },
    checkWord(item, key) {
      //console.log('check work', item, key);
      if (!this.reading) {
        let sliced = _.slice(this.prepareText, 0, key + 1);
        this.countWordsAndSymbold(sliced, this.params.countdownSeconds);
      }
    },

    onHoverWord(item, key, event) {
      if (this.reading) return;
      this.popupTimer = setTimeout(() => {
        let sliced = _.slice(this.prepareText, 0, key + 1);
        let res = this.returnCountWordsAndSymbols(sliced, this.params.countdownSeconds);

        //console.log(event.target.attributes);
        //console.log(event.target.attributes['uk-tooltip'].textContent = '123');
        //console.log(event.target.attributes['uk-tooltip'].value = '123');

        UIkit.tooltip(event.target, {
          title: `Слов в минуту: ${res.words_per_minute}`,
          pos: 'top'
        }).show();
        //console.log(tooltip);
        //tooltip.show();
        //tooltip.$destroy();
      }, 900);
    },

    clearPopup(event) {
      UIkit.tooltip(event.target).$destroy();
      clearTimeout(this.popupTimer);
    },

    onTimesUp() {
      console.log('Время вышло');
      this.timesup = true;
    },
    onLetStop() {
      let seconds = this.params.countdownSeconds * 1000;
      let stop = this.countDown_timer.total_ms;
      let time = (seconds - stop) / 1000;
      console.log(seconds, stop, time);
      clearInterval(this.countDown_id);
      this.reading = false;
      this.countWordsAndSymbold(this.prepareText, time);
    },

    returnCountWordsAndSymbols(arr, seconds) {
      let words = arr.length;
      let withSpaces = arr.join(' ').length;
      let noSpaces = arr.join('').length;

      return {
        'words_per_minute': Math.ceil((words / seconds) * 60),
        'symbols_space_per_minute': Math.ceil((withSpaces / seconds) * 60),
        'symbols_nospace_per_minute': Math.ceil((noSpaces / seconds) * 60)
      };
    },

    countWordsAndSymbold(arr, seconds) {
      //console.log(arr);
      let result = this.returnCountWordsAndSymbols(arr, seconds);
      this.result = result;
      this.params.finish = true;
      console.log(result);
    },

    // Если закончил раньше, сохраняем текущий таймер и отправляем в функцию подсчета время и массив слов

    // Если у текста есть вопросы и ответы, то в конце открыть квиз

    // Твой результат чтения: 451 слов(a) в минуту
    // Процент понимания: 25 %

    clearCountDown() {
      this.countDown_timer = {
        total: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };
      clearInterval(this.countDown_id);
    },
    startCountDown() {
      this.reading = true;
      let duration = moment.duration({
        'seconds': this.params.countdownSeconds,
      });

      this.clearCountDown();
      this.countDown_id = setInterval(() => {
        duration = moment.duration(duration.asMilliseconds() - 100, 'millisecond');
        this.countDown_timer = duration._data;
        this.countDown_timer.total_ms = duration._milliseconds;
        if (duration._milliseconds <= 0) {
          console.log('Финиш!');
          this.clearCountDown();
          this.reading = false;
          this.onTimesUp();
        }
        if (this.finish) {
          this.clearCountDown();
        }
      }, 100);
    },

    // OLD METHODS
    nexStep() {
      this.step++;
      if (this.step == this.cifs.length) {
        this.stopGame();
        this.$parent.commitVal(true, 'finish')
        this.addScores();
        this.makeStats();
        this.startReaction();
      }
    },

    stopGame() {
      this.active = false;
      this.$parent.commitVal(true, 'finish');
    },

    startGame() {
      this.startCountDown();
      this.active = true;
    },
    addScores() {
      let sum = 0;
      if (this.errors < 10) {
        let scores = (this.params.size * this.params.size) * (1 - (this.errors / 10));

        sum = Math.ceil(scores);

        if (this.$route.params.isHomework) {
          sum = Math.ceil(sum * this.$store.state.hw_coefficient);
        }
        this.checkScoreStatus(sum);
        this.scores = sum;
      }
      this.$store.commit('changeUserScores', sum);
      console.log('Баллов заработано', sum);
    },
    makeStats() {
      console.log("Make stats");
      if (this.user.role.code === 'student') {
        console.log('Бережно сохраняем статистику');
        let hasActive = this.active;
        if (!hasActive) {
          let time = this.timer;
          let errors = this.errors;
          let train_params = this.params;
          let stats = {
            time: time,
            errors: errors,
            hasActive: hasActive,
            user_id: this.$store.state.user.id,
            trainer: this.$store.state.current_trainer.id,
            scores: this.scores,
            train_params: {
              direct: train_params.direct,
              size: +train_params.size
            }
          }

          stats = this.checkHomework(stats);
          console.log(stats);
          this.$store.dispatch('saveStats', stats);

        }
      } else {
        console.log('Учителей в статистику не заносим! Понятно?!');
      }
    },
    /** РЕАКЦИИ */
    startReaction() {
      if (this.params.show_reactions) {
        let type = (this.errors === 0 ? 'react_plus' : 'react_minus');
        this.reaction_file = this.checkReaction(type);
        this.reaction = true;
      }
    },
    stopReaction() {
      this.reaction = false;
      let app = this;
      setTimeout(function () {
        app.scroll();
        $('#repeat-' + app.inkey).focus();
      }, 100);
    },
    scroll() {
      UIkit.scroll('.headline2').scrollTo('.game');
    }
  },
  mounted() {
    this.scroll();
    this.params.finish = false;
    this.step = 0;
    this.errors = 0;
    this.reading = true;
    this.timesup = false;
    this.fixMenu()
    this.checkHasText();

  },
  beforeDestroy() {
    //this.makeStats();
    this.$parent.commitVal(false, 'start')
  }
}
</script>

<style lang="scss" scoped>
.readtest__text--blur {
  & span:not(:first-child) {
    filter: blur(3px)
  }
}

.game__name {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;

  & a {
    margin-top: 10px;
  }
}

.trainer__menu {
  margin-top: 10px;
}

.menu-buttons {
  display: flex;
  justify-content: center;

  & a:first-child {
    margin-right: 20px;
  }
}
.finish-btn {
  margin-top: 20px;
  align-self: center;
}
</style>
